import React from "react";
import { Spin } from "antd";
import "../../views/SftpUI/styles.css";

const LoadingComponent = (props) => {
  const { spinning, size } = props;

  return <Spin spinning={spinning} size={size} />;
};

export default LoadingComponent;
